import { turnstile } from '@vp/vue-components';

/**
 * Fan Verification is raised inside the Apollo link, so a dismissed modal rejects whichever
 * operation triggered it — with the reason buried on `ApolloError.networkError`. Read that off by
 * shape rather than with `instanceof ApolloError` (see the vike/SSR note in stores/checkout.ts).
 *
 * Shared, because the challenge wraps *every* operation: the access-code write in Checkout.vue
 * and the seated cart write in SeatsioPicker.vue both meet it, and a buyer who dismisses it must
 * get the same routine message either way rather than an incident report.
 */
export const wasVerificationCancelled = (e: unknown): boolean => {
  const reason = (e as { networkError?: unknown })?.networkError ?? e;

  return reason instanceof turnstile.TurnstileCancelledError;
};
